export default "__VITE_ASSET__ChHYN7ir__"